export default __webpack_public_path__ + "static/media/hotel-sign.378dd653.svg";